<a [href]="pubF?.link" target="_blank">
  <img  *ngIf="pubF?.imageName" [src]="publiciteImageUri + pubF?.imageName" width="100%" alt="Pub F" [title]="pubF?.titre" />
  <!--<img  *ngIf="!pubF?.imageName" src="assets/img/logo/pub2.png" width="100%" alt="Pub F" title="Pub F" />-->
</a>
